import React from "react";
import { injectIntl } from "react-intl";
import { inject, observer } from "mobx-react";
import { BoxIn, PopupOverlay, CloseButton } from "@/views/CommonComponent/Styled/CommonLoadingStyled";
import { Typography, Stack, } from "@mui/material";
import { Icon } from "@iconify/react";
import { StepNumber } from "../Connect/Styled/ConnectStyled";
import PokoroInst from "@/common/Images/PokoroInst.png";
import { LineStyle } from "../Setting/Styled/SettingStyled";


const CommonLoading = (props) => {
  const { text, intl, languageStore, onClose } = props;
  
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <PopupOverlay onClick={handleClose}>
      <BoxIn backgroundColor="#fff">
        <CloseButton onClick={handleClose}>
          <Icon icon="material-symbols:close" fontSize={20}/>
        </CloseButton>
        <Stack gap={3} px={1} width='100%'>
          <Stack gap={1} alignItems='flex-start'>
            <StepNumber>01</StepNumber>
            <Typography variant="body2" whiteSpace='normal'>
              <pre>{intl.formatMessage({ id: "connect_Note01" })}</pre>
            </Typography>
          </Stack>
          <Stack gap={1} alignItems='flex-start' position='relative'>
            <StepNumber>02</StepNumber>
            <Stack flexDirection="row" gap={1}>
              <Typography variant="body2" whiteSpace='normal'>
                <pre>{intl.formatMessage({ id: "connect_Note02" })}</pre>
              </Typography>
              <img src={PokoroInst} alt="Device"/>
            </Stack>
          </Stack>
          <Stack gap={1} alignItems='flex-start'>
            <StepNumber>03</StepNumber>
            <Typography variant="body2" whiteSpace='normal'>
              <pre>{intl.formatMessage({ id: "connect_Note03" })}</pre>
            </Typography>
          </Stack>
        </Stack>
        <LineStyle />
        <Icon icon='eos-icons:three-dots-loading' fontSize={40}/>
        <Typography variant="body1">
          {text}
        </Typography>
      </BoxIn>
    </PopupOverlay>
  );
}
export default injectIntl(
  inject("languageStore")(observer(CommonLoading))
);